module HeaderService {
    angular.module("AdeMesApp").factory("HeaderService", ["$resource", "ConfigService", ($resource: ng.resource.IResourceService, ConfigService: any) => {
        return {
            logout: $resource(ConfigService.resolveServiceUrl("logout"), {
            }, {
                    query: {
                        method: "POST",
                        isArray: false
                    }
                })
        }
    }]);
}